import React, { Component } from "react";
import PropTypes from "prop-types";
import Immutable from "immutable";

import { price } from "../../../lib/utils";
import { getImageUrl } from "../../../lib/url";

/**
 * ExtraProductRow
 */
class ExtraProductRow extends Component {
  static propTypes = {
    product: PropTypes.instanceOf(Immutable.Map).isRequired,
    onRemove: PropTypes.func
  };

  static defaultProps = {
    onRemove: null
  };

  state = {
    removing: false
  };

  onRemove = e => {
    if (e.keyCode && e.keyCode !== 13) {
      return true;
    }
    this.setState({ removing: true });
    setTimeout(() => {
      if (this.props.onRemove) {
        this.props.onRemove(this.props.product);
      }
    }, 150);
    return false;
  };

  render() {
    const { product } = this.props;
    return (
      <div className="Cart__Overview__ProductGroup__ProductRow Cart__Overview__ProductGroup__ProductRow--extraProduct">
        <div className="Cart__Overview__ProductGroup__ProductRow__Title">
          <div className="Cart__Overview__ProductGroup__ProductRow__Image">
            <i className="fa fa-plus" />
          </div>
          <div className="Cart__Overview__ProductGroup__ProductRow__Image">
            <img
              src={getImageUrl({
                id: product.get("imageId"),
                versionId: product.get("imageVersionId")
              })}
              alt={product.get("title")}
            />
          </div>
          <div className="Cart__Overview__ProductGroup__ProductRow__Title__Title">{product.get("title")}</div>
        </div>
        <div className="Cart__Overview__ProductGroup__ProductRow__Price">
          {// eslint-disable-next-line max-len
          price(
            ((product.get("priceEx") * product.get("taxMultiplier") - product.get("discount")) /
              product.get("taxMultiplier")) *
              product.get("quantity", 0)
          )}
        </div>
        <div className="Cart__Overview__ProductGroup__ProductRow__Actions">
          <i
            className={`fa ${this.state.removing ? "fa-spin fa-circle-notch" : "fa-trash"}`}
            onClick={this.onRemove}
            onKeyDown={this.onRemove}
            role="button"
            tabIndex="-1"
          />
        </div>
      </div>
    );
  }
}

export default ExtraProductRow;
